
import { computed, defineComponent, inject } from "vue";
import Calendario from "./Calendario.vue";
import { FormValidatedValuesKey, FormValidatedUpdateKey } from "../../types/inject";

export default defineComponent({
  props: {
    name: {
      type: String,
      required: true,
    },
    tclass: String,
  },
  components: {
    Calendario,
  },
  inheritAttrs: false,
  setup(props) {
    const values = inject(FormValidatedValuesKey, {});

    const onUpdate = inject(FormValidatedUpdateKey);

    const onChangeCal = (date: Date) => {
      typeof onUpdate === "function" && onUpdate({ [props.name]: date });
    };

    return {
      onChangeCal,
      value: computed(() => values[props.name] as Date),
    };
  },
});
